// store/modules/chatbot/getters.js
const getters = {
  loading: (state) => state.loading,

  // ✅ Lista global
  globalChats: (state) => state.list,

  // ✅ Getter para conversaciones de una reserva específica desde la caché
  reservationChats: (state) => (reservationId) => {
    if (!reservationId) return [];
    const key = `reservation_${reservationId}`;
    return state.reservationCache[key] || [];
  },

  // Todos los chats globales
  allChats: (state) => state.list || [],

  // ✅ Verificar si hay mensajes sin leer en global
  hasUnreadGlobal: (state) => {
    return (state.list || []).some((chat) => chat.has_new_message);
  },

  // ✅ Verificar si hay mensajes sin leer en una reserva (usando reservationCache)
  hasUnreadReservation: (state) => (reservationId) => {
    if (!reservationId) return false;
    const key = `reservation_${reservationId}`;
    const chats = state.reservationCache[key] || [];
    return chats.some((chat) => chat.has_new_message);
  },

  rawList: (s) => s.list,
};

export default getters;
